<template>
  <div class="directory-filter-component" :class="disabled ? 'disabled' : ''" >
    <transition-group class="directory-filter-item-wrapper" name="list-complete" tag="div">
        <div class="directory-filter-item list-complete-item mx-2 p-2"
            v-for="(filterField, filterFieldIndex) in dirFilterMixin_categoryTypeFilterData"
            :key="filterField.key"
          >
          <div
            :id="`directory-filter-dropdown-${filterField.key}`"
    
            class="dropdown directory-filter-dropdown"
          >
            <!-- Dropdown Button -->
            <button class="base-pill-category-title directory-filter-dropdown-btn btn btn-secondary dropdown-toggle" @click="dirFilterMixin_dropdownClicked" @keyup.enter="dirFilterMixin_dropdownClicked" data-toggle="dropdown">
              <div id = "directory-filter-dropdown-btn-label">{{filterField.label}}</div>
              <transition-group class="directory-filter-tags-container" name="list-complete" tag="div">
                <b-badge
                  class="directory-tag list-complete-item mx-1"
                  pill
                  v-for="(tag, tagIndex) in userSelection[filterField.key]"
                  :key="tag"
                  >
                  <span class="filter-badge">{{ dirFilterMixin_filterKeyLabelMap[tag] || tag}} </span>
    
                  <span class="filter-remove-badge-button" tabindex="0" @click.stop="dirFilterMixin_removeTag(filterField.key, tag,tagIndex)" @keyup.enter="dirFilterMixin_removeTag(tag,tagIndex)">
                    <i class="filter-tag-icon fa fa-times"></i>
                  </span>
                </b-badge>
              </transition-group>
            </button>
            <!-- The Dropdown Menu -->
            <div class="dropdown-menu" :id="`directory-filter-form-${filterField.key}`"  v-if="event.is_base_style">
              <form class="directory-dropdown-filter-form m-2">
                <div :id="`directory-filter-form-group-${filterField.key}`"
                    class="form-group form-check"
                    v-for="(filterOption, filterOptionIndex) in filterField.values || []"
                    :key="filterField.key + filterOptionIndex.toString()"
                    >
                    <input
                      :id="`directory-filter-option-${filterOption}-${filterFieldIndex}`"
                      :name="`filter-option-${filterOption}-${filterFieldIndex}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="userSelection && userSelection[filterField.key] && userSelection[filterField.key].includes(filterOption)"
                      :value="filterOption"
                      @change="dirFilterMixin_handleUserCheck($event, filterField.key, filterOption)"
                    />
                    <label class="form-check-label" :for="`directory-filter-option-${filterOption}-${filterFieldIndex}`">{{ dirFilterMixin_filterKeyLabelMap[filterOption] || filterOption }}</label>
                </div>
              </form>
            </div>

            <div class="dropdown-menu" :id="`directory-filter-form-${filterField.key}`" v-else>
              <form class="directory-dropdown-filter-form m-2">
                <div :id="`directory-filter-form-group-${filterField.key}`"
                    class="form-group form-check"
                    v-for="(filterOption, filterOptionIndex) in filterField.values || []"
                    :key="filterField.key + filterOptionIndex.toString()"
                    >
                    <input
                      :id="`directory-filter-option-${filterOption}-${filterFieldIndex}`"
                      :name="`filter-option-${filterOption}-${filterFieldIndex}`"
                      class="form-check-input"
                      type="checkbox"
                      :checked="userSelection && userSelection[filterField.key] && userSelection[filterField.key].includes(filterOption)"
                      :value="filterOption"
                      @change="dirFilterMixin_handleUserCheck($event, filterField.key, filterOption)"
                    />
                    <label class="form-check-label" :for="`directory-filter-option-${filterOption}-${filterFieldIndex}`">{{ dirFilterMixin_filterKeyLabelMap[filterOption] || filterOption }}</label>
                </div>
              </form>
            </div>
          </div>
        </div>
    </transition-group>
    <div id="directory-filter-clear-wrapper" v-show="!dirFilterMixin_userSelectionIsEmpty && !event.is_base_style">
      <button class="pill directory-filter-clear-btn" @click="dirFilterMixin_clearClicked" @keyup.enter="dirFilterMixin_clearClicked"><i class="clear-filters-icon fa fa-times"></i> {{dirFilterMixin_clearAllLabel}}</button>
    </div>

    <div id="directory-filter-clear-wrapper" v-show="event.is_base_style">
      <button class="pill directory-filter-clear-btn" @click="dirFilterMixin_clearClicked" @keyup.enter="dirFilterMixin_clearClicked">{{dirFilterMixin_clearAllLabel}}<i class="clear-filters-icon fa fa-times"></i></button>
    </div>
  </div>
</template>

<script>
import { BBadge } from "bootstrap-vue"
import DirectoryFilterMixin from "./DirectoryFilterMixin"
  export default {
    components: {
      BBadge
    },
    mixins: [DirectoryFilterMixin],
    props: {
      filterData: {
        type: Object,
        default: ()=>{
          return {}
        }
      },
      userSelection: {
        type: Object,
        default: ()=>{return {}}
      },
      event: {
        type: Object,
        required: false
      }
    },
    data() {
      return {
        tags: [],
      }
    },
    created(){

    },
    computed: {
    },
    methods: {
    }
  }
</script>

<style scoped>

i.filter-tag-icon.fa.fa-times {
    font-size: 75%;
}

.directory-tag.list-complete-item {
  transition: all .5s;
  display: inline-block;
}
.directory-filter-item.list-complete-item {
  transition: all .5s;
  display: flex;
}
.list-complete-enter, .list-complete-leave-to
/* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-30px);
}
.list-complete-leave-active {
  position: absolute;
}


.directory-filter-tags-container {
  font-size: 18px;
}

.pill {
  border-radius: 10rem;
}

</style>

<style>

.directory-filter-item {
    display: flex;
}
.directory-filter-item-wrapper {
    display: flex;
}
.directory-filter-dropdown-btn.dropdown-toggle {
    display: flex;
    align-items: center;
}
.directory-filter-tags-container {
    display: flex;
}
.directory-filter-component {
  display: flex;
  align-items: center;
}
.directory-filter-clear-btn {
  background: none;
  border: none;
}
.directory-filter-clear-btn i.clear-filters-icon, .directory-filter-clear-btn {
  color: var(--theme-text-color)
}
</style>